<template>
  <div>
    <div v-if="isPc || isTablet" :class="{ snb_open: isSidebarOpen }">
      <footer id="footer">
        <div class="footer_wrap">
          <div class="cont_w">
            <ul class="cont_list">
              <li class="cont_ci logo_box m_foot">
                <img
                  src="@/assets/images/footer_logo.png"
                  alt="푸터로고"
                  class="m_footer_logo"
                />
                <span class="footer_t_box mb_t_box">
                  <span
                    class="r_box footer_t_btn"
                    style="color: #dbdbdb; font-size: 13px;"
                    @click="isShowFooter = !isShowFooter"
                    >사업자 정보

                    <img
                      :style="
                        isShowFooter ? { transform: 'rotateX(-180deg)' } : {}
                      "
                      src="@/assets/images/new_footer/m_f_down.png"
                      alt="화살표"
                      style="width: 14px; vertical-align: middle;"
                    />
                  </span>
                  <ul
                    class="footer_t_list"
                    :style="isShowFooter ? {} : { height: 0 }"
                  >
                    <li class="footer_t_item">
                      <div class="l_box">
                        사업자등록번호.
                      </div>
                      <div class="r_box">
                        486-86-02303
                      </div>
                    </li>
                    <li class="footer_t_item">
                      <div class="l_box">통신판매업신고번호.</div>
                      <div class="r_box">
                        2022-서울마포-0679
                      </div>
                    </li>
                    <li class="footer_t_item">
                      <div class="l_box">
                        주소.
                      </div>
                      <div class="r_box">
                        서울특별시 마포구 양화로 15길 20 마인드월드 5층, 2호
                      </div>
                    </li>
                    <li class="footer_t_item footer mt-1">
                      <div class="l_box">
                        대표. 김진환
                      </div>
                      <div class="r_box">
                        <span class="tir_box w_tir"
                          >대표번호. 070-4432-8810</span
                        >
                        <span class="tir_box m_tir">TEL. 070-4432-8810</span>
                        <span class="tir_box">FAX. 02)326-0668</span>
                      </div>
                    </li>
                  </ul>
                </span>
              </li>
              <li class="footer_util">
                <nav class="cont_link">
                  <router-link :to="{ name: 'CompanyAbout' }">
                    회사소개
                  </router-link>
                  <router-link :to="{ name: 'guide' }">
                    서비스소개
                  </router-link>
                  <router-link :to="{ name: 'terms' }">
                    이용약관
                  </router-link>
                  <router-link :to="{ name: 'privacy' }">
                    개인정보처리방침
                  </router-link>
                  <router-link :to="{ name: 'sitemap' }">
                    사이트맵
                  </router-link>
                  <router-link :to="{ name: 'Partnership' }">
                    사업제휴
                  </router-link>
                  <a href="mailto:admin@campusbook.co.kr">이벤트문의</a>
                </nav>
              </li>
              <li class="m_util">
                <nav class="cont_link">
                  <router-link :to="{ name: 'terms' }">
                    이용약관
                  </router-link>
                  <router-link :to="{ name: 'privacy' }">
                    <b>개인정보처리방침</b>
                  </router-link>
                  <a href="mailto:admin@campusbook.co.kr">
                    이벤트문의
                  </a>
                  <router-link :to="{ name: 'terms' }">
                    사이트맵
                  </router-link>
                </nav>
              </li>
            </ul>
            <ul class="cont_list new_cont_list">
              <li class="cont_ci logo_box pc_f_logo">
                <img src="@/assets/images/footer_logo.png" alt="푸터로고" />
              </li>
              <li class="nth_2">
                <div class="footer_t_box pc_t_box">
                  <span class="l_box">(주) 캠 퍼 스 북</span
                  ><span
                    class="r_box footer_t_btn"
                    style="color: #dbdbdb;"
                    @click="isShowFooter = !isShowFooter"
                    >사업자 정보
                    <img
                      :style="
                        isShowFooter ? { transform: 'rotateX(-180deg)' } : {}
                      "
                      src="@/assets/images/new_footer/m_f_down.png"
                      alt="화살표"
                      style="
                        width: 17px;
                        vertical-align: middle;
                        aspect-ratio: auto 1 / 1;
                      "
                    />
                  </span>
                  <ul
                    class="footer_t_list"
                    :style="isShowFooter ? {} : { height: 0 }"
                  >
                    <li class="footer_t_item">
                      <div class="l_box">
                        사업자등록번호.
                      </div>
                      <div class="r_box">
                        486-86-02303
                      </div>
                    </li>
                    <li class="footer_t_item">
                      <div class="l_box">통신판매업신고번호.</div>
                      <div class="r_box">
                        2022-서울마포-0679
                      </div>
                    </li>
                    <li class="footer_t_item">
                      <div class="l_box">
                        주소.
                      </div>
                      <div class="r_box">
                        서울특별시 마포구 양화로 15길 20 마인드월드 5층, 2호
                      </div>
                    </li>
                    <li class="footer_t_item footer mt-1">
                      <div class="l_box">
                        대표. 김진환
                      </div>
                      <div class="r_box">
                        <span class="tir_box w_tir"
                          >대표번호. 070-4432-8810</span
                        >
                        <span class="tir_box m_tir">TEL. 070-4432-8810</span>
                        <span class="tir_box">FAX. 02)326-0668</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="m_call_box">
                  고객문의
                  <em>070-4432-8810</em>
                  <a href="https://pf.kakao.com/_wxkIdb" target="_blank">
                    1:1 문의하기
                  </a>
                  <router-link :to="{ name: 'faq' }">
                    자주 묻는 질문
                  </router-link>
                  <a href="https://pf.kakao.com/_wxkIdb" target="_blank">
                    상담시간 안내
                  </a>
                </div>
                <div class="new_div">
                  콘텐츠 제공 문의 <span>admin@campusbook.co.kr</span>
                </div>
                <div class="new_div">
                  제휴 및 기타 문의 <span>admin@campusbook.co.kr</span>
                </div>
                <div class="credit uppercase">
                  COPYRIGHT© 2021 CAMPUSBOOK, INC. ALL RIGHTS RESERVED.
                </div>
                <div class="credit uppercase m_credit">
                  <div class="m_sns">
                    <a href=" https://blog.naver.com/campusbook_official"
                      ><img
                        src="@/assets/images/new_footer/m_f_blog.png"
                        alt="블로그"
                      />
                    </a>
                    <a href=" https://www.instagram.com/campus_book/">
                      <img
                        src="@/assets/images/new_footer/m_f_insta.png"
                        alt="인스타그램"
                      />
                    </a>
                    <a href="https://pf.kakao.com/_wxkIdb">
                      <img
                        src="@/assets/images/new_footer/m_f_kakao.png"
                        alt="카카오톡"
                      />
                    </a>
                  </div>
                  <p style="line-height: 13px;">
                    COPYRIGHT© 2021 CAMPUSBOOK, INC. ALL RIGHTS RESERVED.
                  </p>
                </div>
              </li>
              <li class="f_call_box">
                고객문의
                <div class="f_call_num">
                  070-4432-8810
                  <a
                    href="https://www.facebook.com/%EC%BA%A0%ED%8D%BC%EC%8A%A4%EB%B6%81-102120435966328"
                    target="_blank"
                  >
                    <img
                      style="margin-left: 20px;"
                      src="@/assets/images/facebook.png"
                      alt="페이스북"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/campus_book/"
                    target="_blank"
                  >
                    <img
                      src="@/assets/images/insta.png"
                      alt="인스타그램"
                      style="width: 34px;"
                    />
                  </a>
                  <a href="https://pf.kakao.com/_wxkIdb" target="_blank">
                    <img
                      src="@/assets/images/kakao.png"
                      alt="카카오톡문의하기"
                    />
                  </a>
                </div>
                <div class="f_call_faq">
                  <a href="https://pf.kakao.com/_wxkIdb" target="_blank">
                    1:1 문의하기
                  </a>
                  <router-link :to="{ name: 'faq' }">
                    자주 묻는 질문
                  </router-link>
                  <a href="https://pf.kakao.com/_wxkIdb" target="_blank">
                    상담시간 안내
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
    <div v-if="isMobile" :class="{ snb_open: isSidebarOpen }">
      <footer id="footer">
        <div class="inner_wrap">
          <div class="logo_box">
            <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
          </div>
          <button
            class="info"
            :class="{ 'rotated': isShowFooter }"
            @click="isShowFooter = !isShowFooter"
          >
            사업자정보
          </button>
          <ul
            class="address"
            :style="isShowFooter ? { display: 'block' } : { display: 'none' }"
          >
            <li>
              <span>사업자등록번호</span>
              <span>486-86-02303</span>
            </li>
            <li>
              <span>통신판매업신고번호</span>
              <span>2022-서울마포-0679</span>
            </li>
            <li>
              <span>주소</span>
              <span>서울특별시 마포구 양화로 15길 20 마인드월드 5층, 2호</span>
            </li>
            <li>
              <span>대표</span>
              <span>김진환</span>
            </li>
          </ul>
          <div class="email">제휴 및 기타 문의 admin@campusbook.co.kr</div>
          <div class="tel">고객문의 070-4432-8810</div>
          <div class="sns_wrap">
            <a
              href="https://www.facebook.com/%EC%BA%A0%ED%8D%BC%EC%8A%A4%EB%B6%81-102120435966328"
              target="_blank"
            >
              <img src="@/assets/images/facebook.png" alt="페이스북" />
            </a>
            <a href="https://www.instagram.com/campus_book/" target="_blank">
              <img src="@/assets/images/insta.png" alt="인스타그램" />
            </a>
            <a href="https://pf.kakao.com/_wxkIdb" target="_blank">
              <img src="@/assets/images/kakao.png" alt="카카오톡" />
            </a>
          </div>
          <nav class="help_desk">
            <router-link :to="{ name: 'CompanyAbout' }">회사소개</router-link>
            <router-link :to="{ name: 'Partnership' }">
              출판사 제휴 문의
            </router-link>
            <router-link :to="{ name: 'guide' }">
              서비스소개 및 이용가이드
            </router-link>
            <router-link :to="{ name: 'faq' }">고객센터</router-link>
          </nav>
          <div class="copyright">
            COPYRIGHT© 2021 CAMPUSBOOK, INC. ALL RIGHTS RESERVED.
          </div>
        </div>
      </footer>
    </div>
    <transition v-on-clickaway="togglePartnership" name="modal-fade">
      <Modal v-if="showCompanyInfoModal" @close="togglePartnership">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="togglePartnership"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner part_modal">
              <h1 class="txt_head">사업 제휴</h1>
              <div class="txt_wrap">
                <h2 class="base_NM20">(주)캠퍼스북</h2>
                <p class="base_NR14">담당부서 : 캠퍼스북 운영부</p>
                <p class="base_NR14">이 메 일 : admin@campusbook.co.kr</p>
                <p class="base_NR14">전화번호 : 070-4432-8810</p>
              </div>
              <div class="btn_wrap">
                <button class="box_btn" @click="togglePartnership">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import responsiveMixin from '@/mixins/responsive'
import {
  universityName,
  universityLogoUrl,
  universityAddress,
  universityCopyRight
} from '@/store/constants'
export default {
  name: 'Footer',
  mixins: [responsiveMixin],
  data() {
    return {
      universityName,
      universityLogoUrl,
      universityAddress,
      universityCopyRight,
      isShowFooter: false,
      showCompanyInfoModal: false
    }
  },
  computed: {
    ...mapGetters(['isSidebarOpen'])
  },
  methods: {
    togglePartnership() {
      this.showCompanyInfoModal = !this.showCompanyInfoModal
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
#footer {
  .cont_r_wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .footer_util {
    margin-bottom: 13px;
    padding-bottom: 10px;
    width: 100%;
    border-bottom: #abc8d8 1px solid;
  }
  .m_util {
    display: none;
  }
  .credit {
    font-size: 10px;
    padding-top: 10px;
  }
  .cont_w {
    .cont_list {
      .footer_t_box {
        .l_box {
          display: inline-block;
          min-width: 147px;
          padding-right: 11px;
        }
        .justify_text {
          text-align: justify;
          text-align-last: justify;
        }
        .footer_t_btn {
          cursor: pointer;
          position: relative;
        }
        .footer_t_list {
          overflow: hidden;
          transition: all 0.2s;
          margin-top: 0.6rem;
          .footer_t_item {
            display: flex;
            min-width: 560px;
            margin: 4px 0px;
            .tir_box {
              margin-right: 24px;
            }
          }
        }
      }
      .cont_ci {
        margin: 1rem 0rem 0.8rem;
        .ci_conso {
          .footer_logo {
            letter-spacing: 0.2em;
            font-size: 24px;
            line-height: 39px;
          }
          img {
            margin: 0;
            width: auto;
          }
        }
      }
    }
  }
}
#footer .cont_w .cont_list .logo_box img {
  width: 236px;
  aspect-ratio: auto 5.13 / 1;
}
.side-margin {
  margin-left: 32px;
  margin-right: 42px;
}
.line_diagonal {
  display: block;
  border-bottom: 1px solid #ffffff;
  opacity: 0.5;
  width: 45px;
  height: 45px;
  transform: rotate(-45deg) translateY(-45%);
}
#footer .cont_w .cont_list .m_foot,
.credit.uppercase.m_credit,
.footer_t_item.footer.mt-1 .r_box .tir_box.m_tir {
  display: none;
}
.ly_pop_content {
  background-color: $white;
}
.part_modal {
  .txt_head {
    color: $h_BLUE_01;
    font-family: Gmarket-Sans;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    text-align: center;
  }
  .txt_wrap {
    border-top: 1px solid $h_BLUE_01;
    background-color: #f0f5fa;
    padding: 33px 41px;
    h2 {
      margin-bottom: 24px;
      color: $h_BLUE_01;
    }
    p {
      color: grey;
    }
  }
}
.new_cont_list {
  width: 100%;
  display: flex;
  padding-top: 10px;
  .nth_2 {
    max-width: 470px;
  }
  .m_call_box {
    display: none;
  }
  .new_div span {
    padding-left: 10px;
    color: #c7d6de !important;
  }
  .logo_box {
    padding-right: 65px;
  }
  .footer_t_list {
    li {
      color: #c7d6de !important;
      .r_box span {
        color: #c7d6de !important;
      }
    }
  }
  .f_call_box {
    font-size: 17px !important;
    div {
      letter-spacing: 1px;
      margin-top: 15px;
      img {
        margin-right: 10px;
        width: 80px;
      }
    }
    .f_call_num {
      img {
        width: 28px;
        aspect-ratio: auto 1.1 / 1;
        vertical-align: middle;
        margin-top: -5px;
      }
    }
    .f_call_faq {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-top: 15px;
      a {
        padding: 3px 5px;
        background-color: #fff;
        border: 1px solid #c1c1c1;
        border-radius: 3px;
        letter-spacing: 0.2px;
        font-weight: 600;
        font-size: 11px;
        color: #6b6b6b;
      }
    }
  }
}
//모바일 수정 + 추가
#footer .cont_w .cont_list .logo_box.m_foot {
  width: 100%;
  img {
    vertical-align: top;
  }
  .m_footer_logo {
    width: 175px;
    padding-right: 15px;
    padding-top: 4px;
  }
  .PCver {
    width: 52px;
    padding-top: 4px;
    margin-right: 25px;
  }
}
@media (max-width: 1070px) {
  .new_cont_list {
    display: inline-block;
    .nth_2 {
      float: left;
    }
  }
}
@media (max-width: 1024px) {
  .cont_r_wrap {
    justify-content: flex-start !important;
    margin-bottom: 30px;
  }
  .cont_w {
    .cont_list {
      .footer_t_box {
        .l_box {
          min-width: 40px !important;
        }
      }
    }
  }
}
@media (max-width: 806px) {
  .new_cont_list {
    .nth_2 {
      max-width: 400px;
    }
  }
}
@media (max-width: 768px) {
  #footer li,
  #footer p,
  #footer span,
  #footer a {
    font-size: 14px;
    letter-spacing: -0.03em;
  }
  #footer .cont_r_wrap {
    flex-wrap: wrap;
  }
  #footer .ci_conso {
    min-height: auto;
    height: auto;
  }
  .footer_util {
    display: none;
  }

  #footer .m_util {
    display: block;
  }

  #footer .cont_w .cont_list .m_foot,
  .credit.uppercase.m_credit {
    display: block;
  }
  .footer_t_item.footer.mt-1 > .l_box {
    min-width: 70px !important;
  }
  .footer_t_item.footer.mt-1 .r_box .tir_box.m_tir {
    display: inline-block;
  }
  .footer_t_item.footer.mt-1 .r_box .tir_box.w_tir,
  .credit.uppercase {
    display: none;
  }
  #footer .cont_w .cont_list .footer_t_box > .l_box {
    padding-right: 33px;
  }
  #footer {
    .cont_w {
      .cont_list {
        .footer_t_box {
          .footer_t_list {
            .footer_t_item {
              .tir_box {
                margin-right: 15px;
              }
            }
          }
        }
        .credit.uppercase.m_credit {
          opacity: 1;
          margin-top: 0px;
          p {
            font-size: 10px;
            opacity: 0.7;
          }
          .m_sns img {
            width: 22px;
            margin-right: 8px;
            margin-bottom: 3px;
          }
        }
      }
    }
  }
  .pc_f_logo,
  .new_div,
  .f_call_box {
    display: none;
  }
  #footer .new_cont_list .m_call_box {
    display: block;
    margin-top: 10px;
    font-size: 14px;
    em {
      font-size: 11px;
      margin: 0 10px;
    }
    a {
      display: inline-block;
      margin-right: 10px;
      padding: 2px 3px;
      background-color: #fff;
      border: 1px solid #c1c1c1;
      border-radius: 3px;
      font-weight: 600;
      font-size: 10px;
      color: #6b6b6b;
    }
  }
  #footer .footer_util {
    border-bottom: none;
    padding-bottom: 0px;
  }
  .footer_t_list .footer_t_item {
    font-size: 14px !important;
    .r_box span {
      font-size: 14px !important;
    }
  }
  #footer .credit p {
    letter-spacing: 1px;
  }
  .mb_t_box {
    margin-left: 10px;
    .footer_t_btn {
      display: inline-block;
      margin-top: -50px;
    }
  }
  #footer li {
    line-height: 10px;
  }
  #footer .cont_w .cont_list .cont_ci[data-v-041e3202] {
    margin: 1rem 0rem 0rem;
  }
  .pc_t_box {
    display: none;
  }
  #footer .cont_w .cont_list .logo_box.m_foot {
    .mb_t_box .footer_t_list {
      background-color: rgba(0, 0, 0, 0.5);
      width: 94%;
      margin-bottom: 5px;
      li {
        margin-left: 10px;
      }
      li:first-child {
        margin-top: 10px;
      }
      li:last-child {
        margin-bottom: 10px;
      }
      .l_box {
        font-weight: 600;
        font-size: 12px;
      }
      .r_box {
        font-size: 11px;
        opacity: 0.8;
        .tir_box {
          font-size: 10px !important;
          line-height: 14px;
        }
      }
    }
  }
}
@media (max-width: 480px) {
  #footer {
    background-color: #ffffff;
  }
  .logo_box {
    width: 160px;
    height: 31px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .inner_wrap {
    padding: 25px 0 30px 20px;
    .info {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 12px;
      font-size: 14px;
      color: #939393;
      &.rotated::after {
        transform: rotateX(-180deg);
      }
      &::after {
        content: '';
        display: inline-block;
        background: url('../../assets/images/mobile_main/ft_arrow.png')
          no-repeat;
        width: 25px;
        height: 27px;
      }
    }
    .address {
      display: none;
      margin-top: 5px;
      li {
        display: flex;
        gap: 7px;
        span {
          color: #939393 !important;
          &:first-child::after {
            content: ':';
          }
        }
      }
    }
    .email {
      margin-top: 7px;
      font-size: 14px;
      color: #939393;
    }
    .tel {
      margin-top: 7px;
      font-size: 14px;
      color: #939393;
    }
    .sns_wrap {
      margin-top: 15px;
      display: flex;
      gap: 7px;
      > a {
        width: 33px;
        height: 33px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .help_desk {
      display: flex;
      margin-top: 10px;
      gap: 13px;
      a {
        position: relative;
        color: #939393;
        &:not(:last-child)::after {
          content: '|';
          position: absolute;
          top: 0;
          right: -9px;
        }
      }
    }
    .copyright {
      margin-top: 10px;
      font-size: 10px;
      color: #bcbcbc;
    }
  }
}
</style>
